import { useAuth0 } from "@auth0/auth0-react";
import { TableContainer } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import FinanceService from "Lib/API/Finance";
import AlertDialog from "components/Dialog";
import ClearGroupFilter from "components/clearGroupFilter/index";
import Loader from "components/loader/Loader";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from "react-router-dom";
import BatchDocumentsTableData from "./BatchDocumentsTableData";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: "#f3f6f9",
		color: "#4d5565",
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0,
	},
	'.MuiTableCell-head': {
		color: '#4d5565',
		fontWeight: '700',
		fontSize: "12px",
	},
}));
const fetchAPI = async ({ page, setDataTable, setCount, setLoading, getAccessTokenSilently, filter }) => {
	setLoading(true);
	const token = await getAccessTokenSilently();
	if (token) {
		token &&
			(await FinanceService.getBatchDocuments(token, page + 1, 30, filter ? {filter: filter} : {})
				.then((res) => {
					const result = res?.payload?.data;
					setDataTable(result);
					setCount(res?.payload?.pagination?.count);
					setLoading(false);
				})
				.catch((err) => {
					toastr.error("Error", err?.data?.message || err);
				}));
	} else {
		toastr.error("Error", "There is something wrong please contact with support team");
	}
};
export const BatchDocumentsTable = ({ closeCheck }) => {
	const { search } = useLocation();
	const searchParams = new URLSearchParams(search);
	const batchIdParam = searchParams.get("batchId");

	const { getAccessTokenSilently } = useAuth0();
	const [loading, setLoading] = useState(true);
	const [dataTable, setDataTable] = useState([]);
	const [count, setCount] = useState([]);
	const [page, setPage] = useState(0);
	const [switchType, setSwitchType] = useState("bulk-documents");
	const { push } = useHistory();
	const [openConfirmAlert, setOpenConfirmAlert] = useState(false);
	const [batchDocumentId, setBatchDocumentId] = useState(null);
	const [deleteLoading, setDeleteLoading] = useState(false);

	useEffect(() => {
		if(batchIdParam) return;
		fetchAPI({ page, setDataTable, setCount, setLoading, getAccessTokenSilently });
	}, [page, closeCheck,batchIdParam]);

	useEffect(() => {
		if(!batchIdParam) return;
		const filter = {
			batchId: batchIdParam
		}
		setPage(0);
		fetchAPI({ page: 0, setDataTable, setCount, setLoading, getAccessTokenSilently, filter });
	}, [batchIdParam]);

	const deleteBatchDocumentHandler = (row) => {
		setBatchDocumentId(row?._id);
		setOpenConfirmAlert(true);
	};
	const confirmDeleteBatchDocumentHandler = async (row) => {
		if (deleteLoading || !batchDocumentId) return;
		setDeleteLoading(true);
		const token = await getAccessTokenSilently();
		FinanceService.deleteBatchDocument(token, batchDocumentId)
			.then((res) => {
				toastr.success("Success", `Bulk document deleted successfully`);
				fetchAPI({ page, setDataTable, setCount, setLoading, getAccessTokenSilently});
			})
			.catch((err) => {
				toastr.error("Error", err?.data?.message || err);
			})
			.finally(() => {
				setOpenConfirmAlert(false);
				setDeleteLoading(false);
				setBatchDocumentId(null);
			});
	};

	return (
		<div>
			<div>
				<div className="activated-ledger mb-5" style={{ width: "400px" }}>
					<div className="sub-header-functions batch-filter-serach-bar">
						{/* <SearchComp
                            value={filter?.search}
                            setSearchText={onSearchChange}
                            placeholder="Search by account name, status, amount,type"
                        /> */}
					</div>
				</div>
			</div>
			<div className="family-table-container p-7 pb-15">
				<div className="home-table-container mt-0 no-box-shadow">
					<div className="d-flex align-items-center mb-5 h-40px">
						<div
							className="d-flex align-items-center"
							style={{
								height: "36px",
								backgroundColor: "#e7edf9",
								borderRadius: "4px",
							}}
						>
							<button
								type="button"
								onClick={() => {
									setSwitchType("single-documents");
									push({
										pathname: "/finance/documents",
									});
								}}
								className={
									switchType === "single-documents"
										? `btn btn-primary font-weight-bold m-2 d-flex align-items-center`
										: `btn btn-clean font-weight-bold m-2 d-flex align-items-center`
								}
								style={
									switchType === "single-documents"
										? { color: "#FFFFFF", height: "24px" }
										: { color: "#2555EF", height: "24px" }
								}
							>
								Single Documents
							</button>
							<button
								type="button"
								onClick={() => {
									setPage(0);
									setSwitchType("bulk-documents");
									fetchAPI({ page, setDataTable, setCount, setLoading, getAccessTokenSilently });
								}}
								className={
									switchType === "bulk-documents"
										? `btn btn-primary font-weight-bold m-2 d-flex align-items-center`
										: `btn btn-clean font-weight-bold m-2 d-flex align-items-center`
								}
								style={
									switchType === "bulk-documents"
										? { color: "#FFFFFF", height: "24px" }
										: { color: "#2555EF", height: "24px" }
								}
								disabled={loading}
							>
								Bulk Documents
							</button>
						</div>
						{batchIdParam && (
							<div className="ml-4">
								<ClearGroupFilter />
							</div>
						)}
					</div>

					<TableContainer component={Paper} className="scroll-table">
						<Table aria-label="collapsible table">
							<TableHead className="main-table__header sticky-table-header">
								<StyledTableRow>
									<TableCell className="billing-name" align="left">
										NAME
									</TableCell>
									<TableCell className="billing-amount" align="left">
										AMOUNT OF DOCS
									</TableCell>
									<TableCell className="billing-status" align="left">
										STATUS
									</TableCell>
									<TableCell className="billing-type" align="left">
										TYPE
									</TableCell>
									<TableCell className="billing-created-date" align="left">
										CREATED BY
									</TableCell>
									<TableCell className="sticky-header-column"/>
								</StyledTableRow>
							</TableHead>
							<TableBody>
								{dataTable?.length === 0 ? (
									loading === true ? (
										<div className="batch-loader ">
											<Loader />
										</div>
									) : (
										<td colSpan={12}>
											<div className="record-text">No record found</div>
										</td>
									)
								) : loading === true ? (
									<div className="batch-loader ">
										<Loader />
									</div>
								) : (
									dataTable?.map((row) => (
										<BatchDocumentsTableData
											key={row.name}
											row={row}
											deleteBatchDocumentHandler={deleteBatchDocumentHandler}
										/>
									))
								)}
							</TableBody>
						</Table>
					</TableContainer>
					{dataTable?.length !== 0 && (
						<div className="pagination-custom mt-2">
							<Pagination
								count={Math.ceil(count / 30)}
								color="primary"
								variant="outlined"
								onChange={(event, value) => {
									setPage(value - 1);
								}}
							/>
						</div>
					)}
				</div>
				<AlertDialog
					open={openConfirmAlert}
					onDecline={() => {
						setOpenConfirmAlert(false);
					}}
					onAccept={() => {
						confirmDeleteBatchDocumentHandler();
					}}
					title={`Are you sure?`}
					disabled={deleteLoading}
				/>
			</div>
		</div>
	);
};
